import { CURRENCY_CODE } from '@constants/app';
import { Quote } from '@generated/gql/graphql';
import { sumPrices } from '@utils/price';

const getMonthlyCostValue = (quotes: Quote[]) => {
  const totalMonthlyCost = quotes.reduce(
    (acc, quote) => sumPrices(quote.totalMonthlyCost, acc),
    {
      currency: CURRENCY_CODE,
      value: '0',
    }
  );

  return Number(totalMonthlyCost.value);
};

const comparePrices = (expiredCost: number, availableCost: number) => {
  if (expiredCost > availableCost) return 1;
  if (expiredCost < availableCost) return -1;
  return 0;
};

const isMoreExpensive = (expired: Quote[], available: Quote[]) => {
  const expiredCost = getMonthlyCostValue(expired);
  const availableCost = getMonthlyCostValue(available);

  return comparePrices(expiredCost, availableCost) > 0;
};

export { getMonthlyCostValue, isMoreExpensive, comparePrices };
